import React from 'react';
import { componentService } from 'js/services/component.service';

export const Registration = React.lazy(() => import(/* webpackChunkName: "registration" */ './Registration'));

componentService.registerPageComponents({ registration: Registration });
